<template>
  <q-dialog ref="dialogRef" data-test="ConfirmDialog" @hide="onDialogHide">
    <q-card class="r-pa-10">
      <q-card-section class="h2-desktop text-center justify-center pa-0 pb-8">
        <div v-if="heading">
          {{ heading }}
        </div>
      </q-card-section>

      <q-card-section class="pa-0">
        <RelCardInfo v-if="message" class="mb-8" :message="message" />

        <div v-if="info" class="r-mb-8 q-pa-sm bg-ghost-white caption-desktop items-center row">
          <q-icon v-if="icon" :name="icon" size="20px" class="r-mr-1" />
          {{ info }}
        </div>
      </q-card-section>

      <q-card-actions align="around" class="pa-0 row">
        <q-btn
          v-close-popup
          class="mr-2 big-button secondary"
          :label="btnCancel"
          data-test="CancelButton"
          @click="emit('cancel')"
        />
        <q-btn
          v-close-popup
          class="big-button primary"
          :label="btnOk"
          color="primary"
          data-test="OkButton"
          @click="emit('ok')"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue'
import { useDialogPluginComponent } from 'quasar'

const { dialogRef, onDialogHide } = useDialogPluginComponent()

import { RelCardInfo } from '@/components-rel'

const emit = defineEmits([
  ...useDialogPluginComponent.emits,
  'cancel',
  'ok'
])

defineProps({
  heading: {
    type: String,
    default: null,
  },
  message: {
    type: String,
    default: null,
  },
  info: {
    type: String,
    default: null,
  },
  btnCancel: {
    type: String,
    default: 'Cancel',
  },
  btnOk: {
    type: String,
    default: 'OK',
  },
  icon: {
    type: String,
    default: null,
  },
})
</script>

<style lang="scss" scoped>
.q-card__actions {
  justify-content: flex-end;
}
</style>
